// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { updateMoleculeReps } from "../../PyodideTerminal/updateMoleculeReps";
//
export function setTrajSmoothVal(system, smoothVal, molstar, pyodide, vss) {
    return __awaiter(this, void 0, void 0, function* () {
        const moleculeId = system.moleculeID;
        if (!moleculeId)
            return;
        try {
            yield updateMoleculeReps(vss, molstar, pyodide, moleculeId);
        }
        catch (error) {
            console.error(`Error deleting selection: ${error}`);
        }
    });
}
